import SM from "../../components/DashBoard/SM";
import Menu from "../../components/DashBoard/AllUsersMenu";
import styles from "./AllUsers.module.css";
import addIssuer from "./addIssuer.module.css";
import { useEffect, useState, useRef } from "react";
import UserTable from "../../components/DashBoard/UserTable";
import API from "../../ApiConfig";
import cogoToast from "cogo-toast-react-17-fix";
import { Debounce, Logger, NAME_CHECK, EMAIL_CHECK, Delay, NAME_CHECK_WITH_NUMBER, AuthConsole, convertDateFormat } from "../../Utils/helper";
import {
  BASE_URL,
  GET_STATE_COUNT,
  GET_ALL_ISSUERS_WITH_STATE,
  SEND_ONBOARD_EMAIL,
  SEND_ONBOARD_EMAIL_VERIFIER,
  UPDATE_GET_ALL_ISSUERS_WITH_STATE,
  USER_TOKEN,
} from "../../Utils/constant";
import Modal from "../../Utils/Modal";
import Loader from "../../components/Loader";
import AllUsersFilter from "../../components/DashBoard/AllUsersFilter";
import useRefreshToken from "../../Hooks/usegenerateToken";
import SlideUpWrapper from "../../components/Transitions/SlideUpWrapper";
import Pagination from "./ExternalDash/Pagination";
import ShimmerLoader from "../../components/ShimmerLoader";
import { BUTTONS } from "../../Utils/Strings";
import CustomDropDown from "../../components/CustomDropDown";
import usePageTitle from "../../Hooks/useDocTitle";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const AllUsers = () => {
  useRefreshToken(BASE_URL + USER_TOKEN)
  usePageTitle('DashBoard')

  const screenWidth = window.innerWidth;
  let maxShimmer = 7
  if (screenWidth < 500) {
    maxShimmer = 3
  }

  const [activeTab, setActiveTab] = useState({
    name: "All Users",
    link: "all_users",
  });
  const [loading, setLoading] = useState(false);
  const [FilteredList, setFilteredList] = useState(Array(maxShimmer).fill().map((_, index) => index + 1));
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [ListData, setListData] = useState([])
  const [Popup, setPopup] = useState(false);
  const [StateCount, setStateCount] = useState(null);
  const [StateLoad, setStateLoad] = useState(false);

  const [selectedValue, setSelectedValue]=useState("ALL")
  const [sortBy, setSortBy] =useState({
    key:"created_at",
    direction:"desc"
  })
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" })
  const navigate=useNavigate()
  const User=useSelector(state=>state.User)
  useEffect(() => {
    setCurrentPage(1)
  }, [activeTab])

  useEffect(() => {
    getCount()
  }, [])
  async function getCount() {
    setStateLoad(true)
    await Delay()
    API.get(GET_STATE_COUNT)
      .then(res => {
        if (res.status == 200) {
          setStateLoad(false)
          setStateCount(res.data)
        }
      })
      .catch((err) => {
        setStateLoad(false)
        if ((err.response && err.response.status === 403)) {
          //cogoToast.error("Something Went Wrong")
        } else {
          cogoToast.error("Something Went Wrong")
        }
      }
    )
  }

  async function getUsers() {
    setLoading(true)
    await Delay()
    API.get(`${UPDATE_GET_ALL_ISSUERS_WITH_STATE}`, {
      params: {
        page: currentPage,
        status: activeTab.link,
        sort_by:sortBy.key,
        category:selectedValue,
        sort_order:sortBy.direction,

        search:searchText,
        from_date:dateRange.startDate?convertDateFormat(dateRange.startDate):"",
        to_date:dateRange.endDate?convertDateFormat(dateRange.endDate):""

      }
    })
      .then(res => {
        if (res.status === 200 && res.data.data) {
          setLoading(false)
          setFilteredList(res.data.data.items)
          setTotalPages(res.data.data.total_pages)
          setListData(res.data.data.items)           
          
        }
      })
      .catch((err) => {
        setLoading(false);
        if ((err.response && err.response.status === 403)) {
          //cogoToast.error("Something Went Wrong")
        } else {
          cogoToast.error("Something went wrong while fetching list!")
        }
      });
  }
  function handleSearch(e) {
    setSearchText(e);
    setCurrentPage(1)
  }
  useEffect(()=>{
    const delayDebounce = setTimeout(() => {
        getUsers()
    }, 700);
  
    return () => clearTimeout(delayDebounce)
},[searchText,activeTab, currentPage, sortBy, selectedValue,dateRange.endDate])
  const AddSingleUsers = () => {
    const [userForm, setUserForm] = useState({
      company_name: "",
      email: "",
      company_alias: "",
    });
    const [loading, setLoading] = useState(false);
    const [userError, setUserError] = useState({});
    const [Alias, setAlias] = useState("");
    const [verifierType, setVerifierType] = useState('Select Verifier type')

    const [selectVerifierType, setSelectVerifierType] = useState(false)
    const handleAddUser = async (e) => {
      e.preventDefault();
      let isValid = true;
      let tempError = { ...userError };
      if (userForm.issuer == "verifier") {
        navigate("/app/Onboarding")
        // if (verifierType == "General") {
        //   userForm.category = "1"
        // }
        // else if (verifierType == "Visitor") {
        //   userForm.category = "2"
        // }
        // else if (verifierType == "Employment") {
        //   userForm.category = "3"
        // }
        // else {
        //   userForm.category = "";
        // }
        // if (userForm.category === "") {
        //   isValid = false;
        //   tempError["category"] = true;
        // }
      }
      // else {
      //   delete userForm.category;
      // }
      // userForm.category
      if(userForm.issuer!=="verifier"){
      Object.keys(userForm).map((item) => {
        if (userForm[item].length === 0) {
          isValid = false;
          tempError[item] = true;
        } else if (item === "email" && !EMAIL_CHECK(userForm[item])) {
          isValid = false;
          tempError[item] = true;
        } else if (item === "company_name" && !NAME_CHECK_WITH_NUMBER(userForm[item])) {
          isValid = false;
          tempError[item] = true;
        }
        if (item === "company_alias" && userForm[item] == '') {
          isValid = true;
          tempError[item] = false;
        } else if (item === "company_alias" && !NAME_CHECK_WITH_NUMBER(userForm[item])) {
          isValid = false;
          tempError[item] = true;
        }
      });
      const emailAPI = userForm.issuer === "issuer" ? SEND_ONBOARD_EMAIL : userForm.issuer === "verifier" ? SEND_ONBOARD_EMAIL_VERIFIER : null;
      if (emailAPI == null) {
        isValid = false
        tempError["issuer"] = true;
      }
      setUserError(tempError);

      if (!isValid) return;

      setLoading(true);
      await Delay();
      API.post(emailAPI, userForm)
        .then((res) => {
          setLoading(false);
          if (res.status === 200) {
            cogoToast.success("Link Sent to " + userForm.email);
            setPopup(false);
            getUsers()
          } else {
            cogoToast.error(
              userForm.issuer == "issuer"
                ? "Issuer cannot be added"
                : "verifier cannot be"
            );
          }
        })
        .catch((err) => {
          setLoading(false);
          setPopup(false);
          cogoToast.error(err.response.data.message);
        });
      }
    };
    function handleChange(e) {
      let { name, value } = e.target;
      let tempForm = { ...userForm };
      let tempError = { ...userError };
      tempForm[name] = value;
      if (name === "email" && EMAIL_CHECK(value)) {
        delete tempError.email;
      }
      if (name === "company_name" && NAME_CHECK(value)) {
        AuthConsole('company name', tempError.name)
        delete tempError.company_name;
      }
      if (name === "company_alias" && value == '') {
        delete tempError.company_alias;
      } else if (name === "company_alias" && NAME_CHECK(value)) {
        delete tempError.company_alias;
      } else if (name === "company_alias" && !NAME_CHECK(value)) {
        tempError.company_alias = true
      }
      if (name === "issuer" && value.length > 0) {
        delete tempError.issuer;
      }
      if (value === "verifier") {
        setSelectVerifierType(true)
      }
      else if (value === "issuer") {
        setSelectVerifierType(false)
      }
      AuthConsole('errrrrrrrr', tempError)
      setUserError(tempError);
      setUserForm(tempForm);
    }
    function handleDocumentChange(e) {
      setVerifierType(e)
    }
    AuthConsole(verifierType);

    return (
      <form onSubmit={(e) => handleAddUser(e)}>
        <Loader isOpen={loading} />
        <div className={addIssuer.modalBody}>
          Select issuer Type:
          <div className={addIssuer.radioBtn}>
            <label>
              <input
                type="radio"
                value="issuer"
                name="issuer"
                onChange={handleChange}
              />
              Issuer
            </label>
            {/* <label>
              <input
                type="radio"
                value="verifier"
                name="issuer"
                onChange={handleChange}
              />
              Verifier
            </label> */}
            {userError?.issuer ? (
              <p style={{ color: "red" }}>Please select issuer type!</p>
            ) : null}
          </div>
          {selectVerifierType &&
            <CustomDropDown list={['General', 'Visitor', 'Employment']} selectedOption={verifierType} onSelect={e => handleDocumentChange(e)} />}
          {userError?.category ? (
            <p style={{ color: "red" }}>Please chose Verifier type</p>
          ) : null}
          <label className={addIssuer.required}>Company Name </label>
          <div className={addIssuer.emailInput}>
            <input
              name="company_name"
              className={addIssuer.input}
              placeholder="Company Name"
              value={userForm.company_name}
              onChange={handleChange}
            />
            {userError?.company_name ? (
              <p style={{ color: "red" }}>
                Please Enter a Valid Company name !!
              </p>
            ) : null}
          </div>
          <label>Company Alias(optional) </label>
          <div className={addIssuer.emailInput}>
            <input
              name="company_alias"
              className={addIssuer.input}
              placeholder="Company Alias"
              value={userForm.company_alias}
              onChange={handleChange}
            />
            {userError?.company_alias ? (
              <p style={{ color: "red" }}>
                Please Enter a Valid Company alias !!
              </p>
            ) : null}
          </div>

          <label className={addIssuer.required}>Your email </label>
          <div className={addIssuer.emailInput}>
            <input
              name="email"
              className={addIssuer.input}
              placeholder="name@example.com"
              value={userForm.email}
              onChange={handleChange}
            />
            {userError?.email ? (
              <p style={{ color: "red" }}>Please Enter a Valid Email!</p>
            ) : null}
          </div>
          <div
            className={addIssuer.popBtn}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <div className={addIssuer.btn1}>
              <button onClick={() => setPopup(false)} className="secondaryBtn">{BUTTONS.CANCEL}</button>
            </div>
            <div className={addIssuer.btn}>
              <button type="btn btn-primary" disabled={loading} className="Modalbutton">
                {loading ? BUTTONS.ADDING : "Add User"}
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  };

  const Modal1 = ({ title, button, buttonType, content }) => {
    const [toggle, settogle] = useState(false);
    const dropdownRef = useRef(null);
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        settogle(false);
      }
    };

    useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    const ModalData = () => (
      <div className={styles.PopupBackground}>
        <div className={styles.Popup} ref={dropdownRef}>
          <div className={styles.popupHeader}>
            <div className={styles.title}>{title}</div>
            <div className={styles.close} onClick={() => settogle(false)}>
              Clear all
            </div>
          </div>
          <hr />
          {content}
        </div>
      </div>
    );
    if (buttonType == "button") {
      return (
        <>
          <button
            onClick={(e) => {
              e.preventDefault();
              settogle(true);
            }}
          >
            {button}
          </button>
          {toggle && <ModalData />}
        </>
      );
    } else {
      return (
        <>
          <span
            onClick={(e) => {
              e.preventDefault();
              settogle(true);
            }}
          >
            {button}
          </span>
          {toggle && <ModalData />}
        </>
      );
    }
  };

  // function handleActiveTab(e) {
  //   setActiveList([]);
  //   if (e.link === "combinedList") {
  //     setTimeout(() => setActiveList(combinedList), 300);
  //   } else setTimeout(() => setActiveList(apiData[e.link]), 300);
  //   setActiveTab(e);
  // }





  function handleActiveTab(e) {
    if(e.name===activeTab.name){
      return
    }
    else (e.name !== activeTab.name)
      setActiveTab(e);
  }
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  }
  const updatePopup = (bool) => {
    setPopup(bool);
  }
  const handleDateChange = (field, e) => {
    setDateRange((prev) => ({ ...prev, [field]: e }));
  }
  return (
    <SlideUpWrapper direction="slide-right">
      <div className={styles.allUsers}>
        <Loader isOpen={loading} />
        <section className={styles.containerFrame}>
          <div className={styles.hEADERTITLEParent}>
            <div className={styles.tableHeaderFrame}>
              <div className={styles.navbar}>
                <div className={styles.info}>
                  <span className={styles.heading}>Overview</span>
                </div>
              </div>
            </div>
            <div className={styles.searchInputFrame}>
              <SM
                num={StateLoad ? <div className="credentials-table-text"> <ShimmerLoader width='3rem' height='3rem' /></div> :
                  StateCount?.data.pending_onboarding.issuers+StateCount?.data.pending_onboarding.verifiers ?? 0}
                text="Pending Onboarding"
              />
            {User.user_type!=="internal_user"&&  <SM
                num={StateLoad ? <div className="credentials-table-text"> <ShimmerLoader width='3rem' height='3rem' /></div> :
                  StateCount?.data.pending_documents.issuers + StateCount?.data.pending_documents.verifiers ?? 0}
                text="Pending Documents"
              />}
              <SM num={StateLoad ? <div className="credentials-table-text"> <ShimmerLoader width='3rem' height='3rem' /></div> :
                StateCount?.data.completed.issuers + StateCount?.data.completed.verifiers ?? 0} text="Completed" />
            {User.user_type!=="internal_user"&&  <SM num={StateLoad ? <div className="credentials-table-text"> <ShimmerLoader width='3rem' height='3rem' /></div> :
                StateCount?.data.dropped.issuers+StateCount?.data.dropped.verifiers ?? 0} text="Dropped" />}
            </div>
            <div className={styles.frameParent}>
              <Menu menuClick={(e) => handleActiveTab(e)} />
              <div className={styles.navbar}>
                <div className={styles.info1}>
                  {/* <span className={styles.heading}>{activeTab.name}</span> */}
                  {/* <div className={styles.button}> */}
                  <button onClick={(e) => { e.preventDefault(); updatePopup(true) }} className="btn btn-primary" style={{ width: "14%" }}>
                    {/* <div className={styles.button}> */}
                    + Add Issuers
                    {/* + Add Issuers/Verifier */}
                    {/* </div> */}
                  </button>
                  <Modal title="Add Users" isOpen={Popup} onClose={updatePopup} blockOutsideClick={true} children={<AddSingleUsers blockOutsideClick={false} />} />
                  {/* </div> */}
                </div>
              </div>

              <div className={styles.tableHeader}>

                {/* {ListData.length > 0 && */}
                  <div className={styles.inputField2}>
                    <div className={styles.input1}>
                      <div className={styles.content1}>
                        <img
                          className={styles.searchOutlineIcon1}
                          alt=""
                          src="/searchoutline.svg"
                        />
                        <input
                          className={styles.inputText1}
                          value={searchText}
                          placeholder="Search"
                          onChange={(e) => handleSearch(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                <div className={styles.buttons1} style={{margin:"0px 15px"}}>

                  {/* <div className={styles.button5}>
                    <img
                      className={styles.filterIcon}
                      alt=""
                      src="/filter.svg"
                    />
                    <Modal1
                      title="Filters"
                      button="Filter"
                      buttonType="button"
                      content={<AllUsersFilter />}
                    />
                    <img
                      className={styles.chevronDownIcon}
                      alt=""
                      src="/chevrondown.svg"
                    />
                  </div> */}
                  <input
                                type="date"
                                className="datePicker"
                                value={dateRange.startDate}
                                style={{ margin: "10px 25px 0px 25px" }}
                                onChange={(e) => {handleDateChange("startDate", e.target.value);setCurrentPage(1)}}
                              />
                              <input
                                type="date"
                                className="datePicker"
                                value={dateRange.endDate}
                                style={{margin:"10px 25px 0px 25px"}}
                                onChange={(e) => {handleDateChange("endDate", e.target.value);setCurrentPage(1)}}
                              />
                   <CustomDropDown
                                  list={["ALL","ISSUER","VERIFIER"]}
                                  selectedOption={selectedValue}
                                  onSelect={(e) => {setSelectedValue(e);setCurrentPage(1)}}
                                />
                </div>
              </div>
              {loading ?
                ([...Array(5)].map((_, index) => (
                  <tr className="credentials-tr" >
                    <td className="credentials-td flex-grow-2">
                      <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                    </td>
                    {
                      [...Array(5)].map((_, index) => (
                        <td className="credentials-td flex-grow-2" key={index * 10}>
                          <div className="credentials-table-text"> <ShimmerLoader width='10rem' height='1.5rem' /></div>
                        </td>
                      ))
                    }
                  </tr>)
                )):<UserTable refreshList={getUsers} list={FilteredList} activeTab={activeTab} setSortBy={setSortBy} sortBy={sortBy} getCount={getCount} />
              }
            </div>
            <div style={{ margin: "10px" }}>
              <Pagination
                nPages={totalPages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                onPageChange={handlePageChange}
                loading={loading}
              />
            </div>
          </div>
        </section>
      </div>
    </SlideUpWrapper>
  );
};

export default AllUsers;
